import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import { getCstaLink } from 'utils/cstaLink';
import Hr from './Hr';

interface Props {
  title: string;
  listItems: string[];
}

const useStyles = makeStyles({
  list: {
    marginBlockStart: 0,
    display: 'inline-block',
    paddingInlineStart: 'initial',
    '& > li': {
      display: 'inline-block',
      '&:not(:first-child) > *::before': {
        content: "', '",
        display: 'inline-block',
        marginRight: 4,
      },
    },
  },
});

const CstaStandardList: FC<Props> = ({ title, listItems }) => {
  const styles = useStyles();

  if (listItems.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="subtitle1">
        <strong>{title}</strong>
      </Typography>
      <Hr />
      <div>
        <ul className={styles.list}>
          {listItems.map((item, index) => {
            const [level, concept] = item.split('-');
            const url = getCstaLink(level, concept);

            return (
              <li key={index}>
                <Typography variant="body2">
                  {url !== null ? (
                    <Link href={url} target="_blank">
                      {item}
                    </Link>
                  ) : (
                    item
                  )}
                </Typography>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default CstaStandardList;
